export default "__VITE_ASSET__6bK4WYRG__"